export default { install : ( molten ) => {
  // molten.addPlugin( 'Molten.blueprintRelationshipProcessor', {
  //   id : 'analytics.routes',
  //   type : 'analytics.routes',
  //   processRelationship : AnalyticsPages
  // } )
} } 
